export default __webpack_public_path__ + "images/0xc7198437980c041c805a1edcba50c1ce5db95118.png";